export default "__VITE_ASSET__eZg955_A__"